import { createRouter as createVueRouter, createWebHistory } from 'vue-router'

const LoginC = () => import('../components/Auth/LoginC.vue')
const ForgotC = () => import('../components/Auth/ForgotC.vue')
//const CreateAccountByEmail = () => import('../components/Auth/CreateAccountByEmail.vue')

const Dashboard = () => import('../components/Dashboard/Dashboard.vue')
const AdminDashboard = () => import('../components/Dashboard/AdminDashboard.vue')
const MembersList = () => import('../components/Members/List.vue')
const MemberSettings = () => import('../components/Members/Settings.vue')
const MemberVerificationAnswer = () => import('../components/MemberVerification/Answer.vue')
const MembersSingle = () => import('../components/Members/Single.vue')
const MembershipCardList = () => import('../components/MembershipCards/List.vue')
const PaymentsList = () => import('../components/Payments/ListC.vue')
const ReportOverview = () => import('../components/Reports/Overview.vue')
const ApiSecretsSingle = () => import('../components/ApiSecrets/ApiSecretsSingle.vue')
const Logout = () => import('../components/Auth/Logout.vue')
const MembershipCardVerify = () => import('../components/MembershipCards/Verify.vue')
const MembershipCardSingle = () => import('../components/MembershipCards/Single.vue')
const MembershipCardLettersSingle = () => import('../components/MembershipCardLetters/Single.vue')
const MembershipCardVerifyMultiple = () =>
  import('../components/MembershipCards/VerifyMultiple.vue')
const MembershipCardSettings = () => import('../components/MembershipCards/Settings.vue')
const MemberApplicationsList = () => import('../components/MemberApplications/List.vue')
const MemberApplicationsSingle = () => import('../components/MemberApplications/Single.vue')
const MemberApplicationsVerification = () =>
  import('../components/MemberApplications/Verification.vue')
const MemberApplicationSettings = () => import('../components/MemberApplications/Settings.vue')
const MessagesSingle = () => import('../components/Messages/Single.vue')
const MessageSettings = () => import('../components/Messages/Settings.vue')
const NotificationPreferences = () => import('../components/Notifications/Preferences.vue')
const OutboundEmailList = () => import('../components/Notifications/OutboundEmailList.vue')
const NotFound = () => import('../components/NotFound/NotFound.vue')
const PrivacyPolicy = () => import('../components/PrivacyPolicy/PrivacyPolicy.vue')
const DataProcessingAgreement = () =>
  import('../components/DataProcessingAgreement/DataProcessingAgreement.vue')
const PaymentsC = () => import('../components/Payments/PaymentsC.vue')
const PaymentsSingle = () => import('../components/Payments/Single.vue')
const PaymentsUnpaid = () => import('../components/Payments/Unpaid.vue')
const PaymentsUnpaidSingle = () => import('../components/Payments/UnpaidSingle.vue')
const PaymentsNotifyMultiple = () => import('../components/Payments/NotifyMultiple.vue')
const PeopleList = () => import('../components/People/List.vue')
const PeopleSingle = () => import('../components/People/Single.vue')
const PeopleACLSingle = () => import('../components/PeopleACL/Single.vue')

const Recover = () => import('../components/Auth/Recover.vue')

const TransactionList = () => import('../components/Transactions/TransactionList.vue')
const TransactionSingle = () => import('../components/Transactions/TransactionSingle.vue')
const TransactionCategorySingle = () =>
  import('../components/TransactionCategories/TransactionCategorySingle.vue')

const PronobisTransactions = () =>
  import('../components/PronobisTransactions/PronobisTransactions.vue')
const PronobisTransactionDetail = () =>
  import('../components/PronobisTransactions/PronobisTransactionDetail.vue')
const PronobisCostCenterList = () =>
  import('../components/PronobisTransactions/PronobisCostCenterList.vue')

const treasuryNeedsConfig = () => import('../components/Treasury/MissingConfiguration.vue')
const CostCenterManagersMatrix = () => import('../components/CostCenterManagers/Matrix.vue')
const ExpenseSubmissionList = () => import('../components/ExpenseSubmissions/ListC.vue')
const CostCenterTransferList = () => import('../components/CostCenterTransfers/List.vue')
const ExpenseSubmissionSingle = () => import('../components/ExpenseSubmissions/Single.vue')
const ExpenseSubmissionBulk = () => import('../components/ExpenseSubmissions/BulkSubmit.vue')
// #181: the Lotes view is now the admin-only master–detail organiser.
const ExpenseSubmissionBatchList = () =>
  import('../components/ExpenseSubmissions/BatchOrganiser.vue')
const ExpenseSubmissionBatchSingle = () =>
  import('../components/ExpenseSubmissions/BatchSingle.vue')
const InvoiceRequestList = () => import('../components/InvoiceRequests/ListC.vue')
const InvoiceRequestSingle = () => import('../components/InvoiceRequests/Single.vue')
const KmMapList = () => import('../components/KmMaps/ListC.vue')
const OnboardingSingle = () => import('../components/Onboarding/Single.vue')
const KmMapSingle = () => import('../components/KmMaps/Single.vue')
const TreasuryDocList = () => import('../components/TreasuryDocs/ListC.vue')
const TreasuryDocSingle = () => import('../components/TreasuryDocs/Single.vue')
const TreasuryDocsMultiple = () => import('../components/TreasuryDocs/Multiple.vue')
const TreasuryDocSettings = () => import('../components/Treasury/Settings.vue')
const TreasuryMain = () => import('../components/Treasury/TreasuryMain.vue')
const UserSettings = () => import('../components/Users/Settings.vue')
const UsersSingle = () => import('../components/Users/Single.vue')
const CreateUsersInBulk = () => import('../components/Users/CreateUsersInBulk.vue')
const CreateCostCentersInBulk = () => import('../components/People/CreateCostCentersInBulk.vue')
const UsersEditPassword = () => import('../components/Users/EditPassword.vue')
const ChangeLogList = () => import('../components/ChangeLog/List.vue')
const SheetSyncFindings = () => import('../components/SheetSync/Findings.vue')
const Developers = () => import('../components/Developers/Developers.vue')
const OidcClientsSingle = () => import('../components/OidcClients/OidcClientsSingle.vue')
const UiGallery = () => import('../components/ui/gallery/UiGallery.vue')

import { orgTerms, phrase } from '@/terminology'
import { invoiceRequestLabels } from '@/lib/invoiceRequestLabels'

const createRoutes = () => {
  return [
    {
      path: '/',
      name: 'home',
      redirect: '/autorizacao/entrar',
    },
    {
      path: '/autorizacao/entrar',
      name: 'login',
      component: LoginC,
      meta: {
        title: 'Entrar',
      },
    },

    {
      path: '/autorizacao/loginporlink',
      name: 'forgot',
      component: ForgotC,
      meta: {
        title: 'Login Por Link',
      },
    },
    // #237 — public: reachable without login, and linked from the public
    // inscrição form (which is embedded on third-party sites).
    {
      path: '/politica-de-privacidade',
      name: 'privacyPolicy',
      component: PrivacyPolicy,
      meta: {
        title: 'Política de Privacidade',
      },
    },
    // #237 — the coops.pt ↔ org processing contract. Linked from the footer for
    // admins/editors only; the component itself also gates on that role.
    {
      path: '/contrato-de-subcontratacao',
      name: 'dataProcessingAgreement',
      component: DataProcessingAgreement,
      meta: {
        title: 'Contrato de Subcontratação',
      },
    },
    /*{
      path: '/autorizacao/criarPorEmail',
      name: 'createAccountByEmail',
      component: CreateAccountByEmail,
      meta: {
        title: 'Criar Conta',
      },
    },*/
    {
      path: '/adminHome',
      name: 'adminHome',
      component: AdminDashboard,
      meta: {
        title: 'Página Inicial',
        breadcrumb: 'Painel',
        module: 'dashboard',
      },
    },
    {
      path: '/dashboard',
      name: 'memberHome',
      component: Dashboard,
      meta: {
        title: 'Página Inicial',
        breadcrumb: orgTerms.memberSingular,
        module: 'dashboard',
      },
    },
    {
      path: '/' + orgTerms.memberURLPlural,
      name: 'membersList',
      component: MembersList,
      meta: {
        title: orgTerms.memberPlural,
        breadcrumb: orgTerms.memberPlural,
        module: 'members',
      },
    },
    {
      path: '/' + orgTerms.memberURLPlural + '/novo',
      name: 'membersNew',
      component: MembersSingle,
      meta: {
        title: phrase('newMember', 'Novo ' + orgTerms.memberSingular),
        breadcrumb: phrase('newMember', 'Novo ' + orgTerms.memberSingular),
        module: 'members',
      },
    },
    {
      path: '/' + orgTerms.memberURLPlural + '/:id',
      name: 'membersEdit',
      component: MembersSingle,
      meta: {
        title: 'Editar ' + orgTerms.memberSingular,
        breadcrumb: 'Editar ' + orgTerms.memberSingular,
        module: 'members',
      },
    },
    {
      path:
        '/configuracao' +
        orgTerms.memberURLPlural.charAt(0).toUpperCase() +
        orgTerms.memberURLPlural.substring(1),
      name: 'memberSettings',
      component: MemberSettings,
      meta: {
        title: 'Configurações – ' + orgTerms.memberPlural,
        breadcrumb: 'Configurações – ' + orgTerms.memberPlural,
        module: 'settings',
      },
    },
    {
      path: '/' + orgTerms.memberURLPlural + '/candidaturas/nova',
      name: 'memberApplicationsNew',
      component: MemberApplicationsSingle,
      meta: {
        title: 'Nova Candidatura',
        breadcrumb: 'Nova Candidatura',
        module: 'members',
      },
    },
    {
      path: '/' + orgTerms.memberURLPlural + '/candidaturas/:id',
      name: 'memberApplicationsEdit',
      component: MemberApplicationsSingle,
      meta: {
        title: 'Editar candidatura de ' + orgTerms.memberSingular,
        breadcrumb: 'Editar candidatura de ' + orgTerms.memberSingular,
        module: 'members',
      },
    },
    {
      path: '/' + orgTerms.memberURLPlural + '/candidaturas',
      name: 'memberApplicationsList',
      component: MemberApplicationsList,
      meta: {
        title: 'Candidaturas a ' + orgTerms.memberSingular,
        breadcrumb: 'Candidaturas a ' + orgTerms.memberSingular,
        module: 'members',
      },
    },
    {
      path: '/configuracaoCandidaturas',
      name: 'memberApplicationSettings',
      component: MemberApplicationSettings,
      meta: {
        title: 'Configurações – Candidaturas a ' + orgTerms.memberSingular,
        breadcrumb: 'Configurações – Candidaturas a ' + orgTerms.memberSingular,
        module: 'settings',
      },
    },
    {
      path: '/inscricao/confirmacao/:verificationCode',
      name: 'memberApplicationsVarification',
      component: MemberApplicationsVerification,
      meta: {
        title: 'Verificação de Email',
        breadcrumb: 'Verificação de Email',
      },
    },

    {
      // #501 — where a member with an open verification is held.
      path: '/os-meus-dados',
      name: 'memberVerification',
      component: MemberVerificationAnswer,
      meta: {
        title: 'Os meus dados',
        breadcrumb: 'Os meus dados',
      },
    },
    {
      path: '/autorizacao/sair',
      name: 'logout',
      component: Logout,
    },
    {
      path: '/autorizacao/loginporlink/:recoverCode',
      name: 'recover',
      component: Recover,
      meta: {
        title: 'Login Por Link',
        breadcrumb: 'Login por Link',
      },
    },
    {
      path:
        '/cartoes' +
        orgTerms.memberURLSingular.charAt(0).toUpperCase() +
        orgTerms.memberURLSingular.substring(1),
      name: 'membershipCardList',
      component: MembershipCardList,
      meta: {
        title: 'Cartões de ' + orgTerms.memberSingular,
        module: 'membershipCards',
        breadcrumb: 'Cartões de ' + orgTerms.memberSingular,
      },
    },
    {
      path:
        '/cartoes' +
        orgTerms.memberURLSingular.charAt(0).toUpperCase() +
        orgTerms.memberURLSingular.substring(1) +
        '/verificarVarios/:id?',
      name: 'membershipCardVerifyMultiple',
      component: MembershipCardVerifyMultiple,
      meta: {
        title: 'Verificar Cartões de ' + orgTerms.memberSingular,
        module: 'membershipCards',
        breadcrumb: 'Verificar Cartões de ' + orgTerms.memberSingular,
      },
    },
    {
      path:
        '/cartoes' +
        orgTerms.memberURLSingular.charAt(0).toUpperCase() +
        orgTerms.memberURLSingular.substring(1) +
        '/:id',
      name: 'membershipCardSingle',
      component: MembershipCardSingle,
      meta: {
        module: 'membershipCards',
        breadcrumb: 'Cartões de ' + orgTerms.memberSingular,
      },
    },
    {
      path:
        '/cartaCartoes' +
        orgTerms.memberURLSingular.charAt(0).toUpperCase() +
        orgTerms.memberURLSingular.substring(1) +
        '/:id',
      name: 'membershipCardLettersSingle',
      component: MembershipCardLettersSingle,
      meta: {
        module: 'membershipCards',
        breadcrumb: 'Carta envio de Cartão de ' + orgTerms.memberSingular,
      },
    },
    {
      path: '/v/:id',
      name: 'membershipCardVerify',
      component: MembershipCardVerify,
      meta: {
        module: 'membershipCards',
        breadcrumb: 'Cartões de ' + orgTerms.memberSingular,
      },
    },

    {
      path:
        '/configuracaoCartoes' +
        orgTerms.memberURLPlural.charAt(0).toUpperCase() +
        orgTerms.memberURLPlural.substring(1),
      name: 'membershipCardSettings',
      component: MembershipCardSettings,
      meta: {
        title: 'Configurações – Cartão de ' + orgTerms.memberPlural,
        breadcrumb: 'Configurações – Cartão de' + orgTerms.memberPlural,
        module: 'settings',
      },
    },

    {
      path: '/' + orgTerms.memberURLPlural + '/' + orgTerms.membershipPaymentsURL,
      name: 'PaymentsC',
      component: PaymentsC,
      meta: {
        title: orgTerms.membershipPayments,
        module: 'members',
        breadcrumb: orgTerms.membershipPayments,
      },
    },
    {
      path: '/' + orgTerms.memberURLPlural + '/' + orgTerms.membershipPaymentsURL + '/pagamentos',
      name: 'paymentsList',
      component: PaymentsList,
      meta: {
        title: orgTerms.membershipPayments + ' – Pagamentos',
        module: 'members',
        breadcrumb: 'Pagamentos',
      },
    },
    {
      path: '/' + orgTerms.memberURLPlural + '/' + orgTerms.membershipPaymentsURL + '/dividas',
      name: 'unpaid',
      component: PaymentsUnpaid,
      meta: {
        title: orgTerms.membershipPayments + ' – Dívidas',
        module: 'members',
        breadcrumb: 'Dívidas',
      },
    },
    {
      path: '/informacaoDePagamento/:id',
      name: 'unpaidSingle',
      component: PaymentsUnpaidSingle,
      meta: {
        title: orgTerms.membershipPayments + ' – Informação de Pagamento',
        breadcrumb: 'Dívidas',
        module: 'members',
      },
    },
    {
      path:
        '/' +
        orgTerms.memberURLPlural +
        '/' +
        orgTerms.membershipPaymentsURL +
        '/notificar' +
        orgTerms.memberURLPlural.charAt(0).toUpperCase() +
        orgTerms.memberURLPlural.substring(1),
      name: 'paymentsNotifyMultiple',
      component: PaymentsNotifyMultiple,
      meta: {
        title: orgTerms.membershipPayments + '– Notificar ' + orgTerms.memberPlural,
        module: 'members',
        breadcrumb: 'Preparar Notificação',
      },
    },
    {
      path:
        '/' +
        orgTerms.memberURLPlural +
        '/' +
        orgTerms.membershipPaymentsURL +
        '/dividas/:memberId',
      name: 'unpaidByMember',
      component: PaymentsUnpaid,
      meta: {
        title: orgTerms.membershipPayments + '– Dívidas de ' + orgTerms.memberSingular,
        module: 'members',
        breadcrumb: 'Dívidas',
      },
    },
    {
      path:
        '/' + orgTerms.memberURLPlural + '/' + orgTerms.membershipPaymentsURL + '/pagamentos/novo',
      name: 'paymentsNew',
      component: PaymentsSingle,
      meta: {
        title: orgTerms.membershipPayments + '– Novo Pagamento',
        module: 'members',
        breadcrumb: 'Novo Pagamento',
      },
    },
    {
      path: '/' + orgTerms.memberURLPlural + '/pagamentos/:id',
      name: 'paymentsEdit',
      component: PaymentsSingle,
      meta: {
        title: orgTerms.membershipPayments + '– Editar Pagamento',
        module: 'members',
        breadcrumb: 'Editar Pagamento',
      },
    },
    {
      path: '/utilizadores',
      name: 'userSettings',
      component: UserSettings,
      meta: {
        title: 'Configurações – Utilizadores',
        breadcrumb: 'Utilizadores',
        module: 'settings',
        access: ['admin', 'editor'],
      },
    },
    {
      path: '/utilizadores/novo',
      name: 'usersNew',
      component: UsersSingle,
      meta: {
        title: 'Utilizadores – Novo Utilizador',
        breadcrumb: 'Novo Utilizador',
        module: 'settings',
      },
    },
    {
      path: '/utilizadores/criarMultiplos',
      name: 'usersMultiple',
      component: CreateUsersInBulk,
      meta: {
        title: 'Utilizadores – Criar Conta para Todos',
        breadcrumb: 'Criar Conta para Todos',
        module: 'settings',
      },
    },
    // #411 — the id is not optional here: Auth/Recover.vue only reaches this
    // route after a login link, with the id of the account whose password is
    // being set. Truncated to `/utilizadores/recuperar-password`, the path had
    // no route of its own and was swallowed by `/utilizadores/:id` below, which
    // then read a "user" literally called `recuperar-password` — 401 for a
    // cooperador, an uncaught rejection reported to Sentry, and an empty ficha
    // on screen. Give the id-less path the not-found page it always deserved,
    // ahead of the `:id` route that would otherwise win.
    {
      path: '/utilizadores/recuperar-password',
      name: 'usersEditPasswordNoId',
      component: NotFound,
      meta: {
        title: 'Página não encontrada',
        breadcrumb: 'Página não encontrada',
      },
    },
    {
      path: '/utilizadores/recuperar-password/:id',
      name: 'usersEditPassword',
      component: UsersEditPassword,
      meta: {
        title: 'Utilizadores – Recuperar Password',
        breadcrumb: 'Recuperar Password',
        module: '',
      },
    },
    {
      path: '/utilizadores/:id',
      name: 'usersEdit',
      component: UsersSingle,
      meta: {
        title: 'Editar Utilizador',
        breadcrumb: 'Editar Utilizador',
        module: 'settings',
      },
    },
    {
      path: '/relatorios',
      name: 'reportOverview',
      component: ReportOverview,
      meta: {
        title: 'Relatórios',
        breadcrumb: 'Relatórios',
      },
    },
    {
      path: '/configuracaoNotificacoes',
      name: 'notificationPreferences',
      component: NotificationPreferences,
      meta: {
        title: 'Configuração – Notificações',
        breadcrumb: 'Configuração – Notificações',
        module: 'settings',
      },
    },
    {
      path: '/mensagens',
      name: 'messageList',
      component: OutboundEmailList,
      meta: {
        title: 'Mensagens',
        breadcrumb: 'Mensagens',
      },
    },
    {
      path: '/mensagens/:id',
      name: 'outboundEmailsEdit',
      component: MessagesSingle,
      meta: {
        title: 'Mensagens – Ver Mensagem',
        breadcrumb: 'Ver Mensagem',
      },
    },
    {
      path: '/configuracaoMensagens',
      name: 'messageSettings',
      component: MessageSettings,
      meta: {
        title: 'Configuração – Mensagens',
        breadcrumb: 'Configuração – Mensagens',
        module: 'settings',
      },
    },
    {
      path: '/tesouraria',
      name: 'treasuryMain',
      component: TreasuryMain,
      meta: {
        title: 'Tesouraria',
        breadcrumb: 'Tesouraria',
        module: 'treasury',
      },
    },
    {
      path: '/tesouraria/naoConfigurado',
      name: 'treasuryNeedsConfig',
      component: treasuryNeedsConfig,
      meta: {
        title: 'Tesouraria',
        breadcrumb: 'Tesouraria',
        module: 'treasury',
      },
    },
    {
      path: '/tesouraria/despesas',
      name: 'expenseSubmissionList',
      component: ExpenseSubmissionList,
      meta: {
        title: 'Tesouraria - Despesas',
        breadcrumb: 'Despesas',
        module: 'treasury',
      },
    },
    {
      // #514 — reachable by anyone logged in, like every route (meta is not a
      // guard); the API scopes and gates what it returns.
      path: '/tesouraria/transferencias',
      name: 'costCenterTransferList',
      component: CostCenterTransferList,
      meta: {
        title: 'Tesouraria - Transferências',
        breadcrumb: 'Transferências',
        module: 'treasury',
      },
    },
    {
      path: '/tesouraria/despesas/nova',
      name: 'expenseSubmissionsNew',
      component: ExpenseSubmissionSingle,
      meta: {
        title: 'Tesouraria - Nova Despesa',
        breadcrumb: 'Nova Despesa',
        module: 'treasury',
      },
    },
    {
      path: '/tesouraria/despesas/submeter-varias',
      name: 'expenseSubmissionsBulk',
      component: ExpenseSubmissionBulk,
      meta: {
        title: 'Tesouraria - Submeter Várias Despesas',
        breadcrumb: 'Submeter Várias',
        module: 'treasury',
      },
    },
    {
      path: '/tesouraria/lotes',
      name: 'expenseSubmissionBatchList',
      component: ExpenseSubmissionBatchList,
      meta: {
        title: 'Tesouraria - Lotes de Despesas',
        breadcrumb: 'Lotes',
        module: 'treasury',
      },
    },
    {
      path: '/tesouraria/lotes/:id',
      name: 'expenseSubmissionBatchSingle',
      component: ExpenseSubmissionBatchSingle,
      meta: {
        title: 'Tesouraria - Lote',
        breadcrumb: 'Lote',
        module: 'treasury',
      },
    },
    {
      path: '/tesouraria/despesas/:id',
      name: 'expenseSubmissionsEdit',
      component: ExpenseSubmissionSingle,
      meta: {
        title: 'Tesouraria - Editar Despesa',
        breadcrumb: 'Editar Despesa',
        module: 'treasury',
      },
    },
    {
      path: '/tesouraria/pedidos-factura',
      name: 'invoiceRequestList',
      component: InvoiceRequestList,
      meta: {
        title: 'Tesouraria - ' + invoiceRequestLabels.plural,
        breadcrumb: invoiceRequestLabels.plural,
        module: 'treasury',
      },
    },
    {
      path: '/tesouraria/pedidos-factura/novo',
      name: 'invoiceRequestNew',
      component: InvoiceRequestSingle,
      meta: {
        title: 'Tesouraria - ' + invoiceRequestLabels.newSingular,
        breadcrumb: invoiceRequestLabels.newShort,
        module: 'treasury',
      },
    },
    {
      path: '/tesouraria/pedidos-factura/:id',
      name: 'invoiceRequestEdit',
      component: InvoiceRequestSingle,
      meta: {
        title: 'Tesouraria - ' + invoiceRequestLabels.singular,
        breadcrumb: invoiceRequestLabels.short,
        module: 'treasury',
      },
    },
    {
      // #469 — meta.access here is COSMETIC. There is no route guard in this
      // app; the menu v-if and this entry decide what is drawn and nothing
      // more. Closing onboarding off is onboardingEnabled() in
      // api/routes/onboarding.go, which 404s every endpoint when the setting
      // is false.
      path: '/onboarding',
      name: 'onboarding',
      component: OnboardingSingle,
      meta: {
        title: 'Onboarding',
        breadcrumb: 'Onboarding',
      },
    },
    {
      path: '/tesouraria/mapas-km',
      name: 'kmMapList',
      component: KmMapList,
      meta: {
        title: 'Tesouraria - Mapas de Deslocação',
        breadcrumb: 'Mapas de Deslocação',
        module: 'treasury',
      },
    },
    {
      path: '/tesouraria/mapas-km/novo',
      name: 'kmMapNew',
      component: KmMapSingle,
      meta: {
        title: 'Tesouraria - Novo Mapa de Deslocação',
        breadcrumb: 'Novo Mapa',
        module: 'treasury',
      },
    },
    {
      path: '/tesouraria/mapas-km/:id',
      name: 'kmMapEdit',
      component: KmMapSingle,
      meta: {
        title: 'Tesouraria - Mapa de Deslocação',
        breadcrumb: 'Mapa',
        module: 'treasury',
      },
    },
    {
      path: '/tesouraria/documentos',
      name: 'treasuryDocList',
      component: TreasuryDocList,
      meta: {
        title: 'Tesouraria',
        breadcrumb: 'Tesouraria',
        module: 'treasury',
      },
    },
    {
      path: '/tesouraria/documentos/novo',
      name: 'treasuryDocsNew',
      component: TreasuryDocSingle,
      meta: {
        title: 'Tesouraria – Novo Documento',
        breadcrumb: 'Novo Documento',
        module: 'treasury',
      },
    },
    {
      path: '/tesouraria/documentos/multiplos',
      name: 'treasuryDocsMultiple',
      component: TreasuryDocsMultiple,
      meta: {
        title: 'Tesouraria – Múltiplos',
        breadcrumb: 'Multiplos',
        module: 'treasury',
      },
    },
    {
      path: '/tesouraria/documentos/:id',
      name: 'treasuryDocsEdit',
      component: TreasuryDocSingle,
      meta: {
        title: 'Tesouraria – Editar Documento',
        breadcrumb: 'Editar Documento',
        module: 'treasury',
      },
    },
    {
      path: '/tesouraria/centrosDeCustos/novo',
      name: 'costCenterNew',
      component: PeopleSingle,
      meta: {
        module: 'treasury',
        title: 'Tesouraria - Centros de Custo - Novo',
        breadcrumb: 'Centros de Custo',
      },
    },
    {
      path: '/tesouraria/centrosDeCustos/:id',
      name: 'costCenterEdit',
      component: PeopleSingle,
      meta: {
        module: 'treasury',
        title: 'Tesouraria - Centros de Custo - Editar',
        breadcrumb: 'Centros de Custo',
      },
    },
    {
      path: '/tesouraria/centrosDeCustos',
      name: 'costCenterList',
      component: PeopleList,
      meta: {
        module: 'treasury',
        title: 'Tesouraria - Centros de Custo',
        breadcrumb: 'Centros de Custo',
        access: ['admin', 'editor'],
      },
    },
    {
      // #198 — admin × cost-center responsibility matrix. Admin-only; the nav
      // link is shown only when hasTaskDistribution is on.
      path: '/tesouraria/distribuicaoDeTarefas',
      name: 'costCenterManagers',
      component: CostCenterManagersMatrix,
      meta: {
        module: 'treasury',
        title: 'Tesouraria - Distribuição de Tarefas',
        breadcrumb: 'Distribuição de Tarefas',
        access: ['admin'],
      },
    },
    {
      path: '/tesouraria/entidadesExternas/novo',
      name: 'externalEntityNew',
      component: PeopleSingle,
      meta: {
        module: 'treasury',
        title: 'Tesouraria - Entidades Externas - Novo',
        breadcrumb: 'Entidades Externas',
      },
    },
    {
      path: '/tesouraria/entidadesExternas/:id',
      name: 'externalEntityEdit',
      component: PeopleSingle,
      meta: {
        module: 'treasury',
        title: 'Tesouraria - Entidades Externas - Editar',
        breadcrumb: 'Entidades Externas',
      },
    },
    {
      path: '/tesouraria/entidadesExternas',
      name: 'externalEntityList',
      component: PeopleList,
      meta: {
        module: 'treasury',
        title: 'Tesouraria - Entidades Externas',
        breadcrumb: 'Entidades Externas',
      },
    },
    {
      path: '/tesouraria/acessosAoCentrosDeCusto/novo',
      name: 'peopleACLNew',
      component: PeopleACLSingle,
      meta: {
        module: 'treasury',
        title: 'Tesouraria - Acesso ao Centros de Custo - Novo',
        breadcrumb: 'Centros de Custo',
      },
    },
    {
      path: '/tesouraria/acessosAoCentrosDeCusto/:id',
      name: 'peopleACLEdit',
      component: PeopleACLSingle,
      meta: {
        module: 'treasury',
        title: 'Tesouraria - Acesso ao Centros de Custo - Editar',
        breadcrumb: 'Centros de Custo',
      },
    },

    {
      path: '/tesouraria/transaccoes',
      name: import.meta.env.VITE_CLIENT === 'pronobis' ? 'pronobisTransactionList' : 'transactionList',
      component: import.meta.env.VITE_CLIENT === 'pronobis' ? PronobisCostCenterList : TransactionList,
      meta: {
        module: 'treasury',
        title: 'Tesouraria - Transacções',
        breadcrumb: 'Transacções',
      },
    },
    {
      path: '/tesouraria/transaccoes/nova',
      name: 'transactionsNew',
      component: TransactionSingle,
      meta: {
        module: 'treasury',
        title: 'Tesouraria - Nova Transacção',
        breadcrumb: 'Nova',
      },
    },
    {
      path: '/tesouraria/transaccoes/:id',
      name: 'transactionsEdit',
      component: TransactionSingle,
      meta: {
        module: 'treasury',
        title: 'Tesouraria - Editar Transacção',
        breadcrumb: 'Editar',
      },
    },

    {
      path: '/tesouraria/centrosDeCustos/:id/transaccoes',
      name: 'transactionPerCostCenterList',
      component:
        import.meta.env.VITE_CLIENT === 'pronobis' ? PronobisTransactionDetail : TransactionList,
      meta: {
        module: 'treasury',
        title: 'Tesouraria - Transacções por centro de custo',
        breadcrumb: 'Transacções por centro de custo',
      },
    },
    {
      path: '/tesouraria/entidadesExternas/:id/transaccoes',
      name: 'transactionPerExternalEntityList',
      component: TransactionList,
      meta: {
        module: 'treasury',
        title: 'Tesouraria - Transacções por Entidade Externa',
        breadcrumb: 'Transacções por entidade externa',
      },
    },
    {
      path: '/tesouraria/categoriasDeTransaccao/nova',
      name: 'transactionCategoriesNew',
      component: TransactionCategorySingle,
      meta: {
        module: 'settings',
        title: 'Tesouraria - Nova Categoria de Transacção',
        breadcrumb: 'Nova',
      },
    },
    {
      path: '/tesouraria/categoriasDeTransaccao/:id',
      name: 'transactionCategoriesEdit',
      component: TransactionCategorySingle,
      meta: {
        module: 'settings',
        title: 'Tesouraria - Editar Categoria de Transacção',
        breadcrumb: 'Editar',
      },
    },
    {
      path: '/tesouraria/importador',
      name: 'transactionImporterList',
      component: PronobisTransactions,
      meta: {
        module: 'treasury',
        title: 'Tesouraria - Importador',
        breadcrumb: 'Importador',
      },
    },

    {
      path: '/configuracaoTesouraria/criarMultiplos',
      name: 'CostCenterMultiple',
      component: CreateCostCentersInBulk,
      meta: {
        title: 'Configurações Tesouraria – Criar Centro de Custo para Todos',
        breadcrumb: 'Criar Centro de Custo para Todos',
        module: 'settings',
      },
    },

    {
      path: '/configuracaoTesouraria',
      name: 'treasuryDocSettings',
      component: TreasuryDocSettings,
      meta: {
        title: 'Configurações – Tesouraria',
        breadcrumb: 'Configurações de Tesouraria',
        module: 'settings',
      },
    },

    {
      // #467 — Minga only (the API answers 404 elsewhere); admin only.
      path: '/importacao-folhas',
      name: 'sheetSyncFindings',
      component: SheetSyncFindings,
      meta: {
        title: 'Importação das folhas',
        breadcrumb: 'Importação das folhas',
        module: 'settings',
        access: ['admin'],
      },
    },
    {
      path: '/historico',
      name: 'changeLogList',
      component: ChangeLogList,
      meta: {
        title: 'Histórico de Alterações',
        breadcrumb: 'Histórico de Alterações',
        module: 'settings',
        access: ['admin', 'editor'],
      },
    },
    // #548 — the component gallery. `__UI_GALLERY__` is a build-time literal
    // (front/buildFlags.js): false in every production bundle, where this entry
    // and the lazy chunk behind it are removed. Linked from nowhere.
    ...(__UI_GALLERY__
      ? [
          {
            path: '/ui-gallery',
            name: 'uiGallery',
            component: UiGallery,
            meta: {
              title: 'Galeria de componentes',
              breadcrumb: 'Galeria de componentes',
              module: 'settings',
            },
          },
        ]
      : []),
    {
      path: '/developers',
      name: 'developers',
      component: Developers,
      meta: {
        title: 'Configurações – Programadores',
        breadcrumb: 'Configurações – Programadores',
        module: 'settings',
      },
    },
    {
      path: '/apiSecrets/new',
      name: 'apiSecretsNew',
      component: ApiSecretsSingle,
      meta: {
        title: 'Configurações – API – Nova Chave',
        breadcrumb: 'Configurações – API – Nova Chave',
        module: 'settings',
      },
    },
    {
      path: '/apiSecrets/:id',
      name: 'apiSecretsEdit',
      component: ApiSecretsSingle,
      meta: {
        title: 'API – Editar Chave',
        breadcrumb: 'Editar Chave API',
        module: 'settings',
      },
    },
    {
      path: '/oidcClients/new',
      name: 'oidcClientsNew',
      component: OidcClientsSingle,
      meta: {
        title: 'Configurações – OIDC – Nova Aplicação',
        breadcrumb: 'Configurações – OIDC – Nova Aplicação',
        module: 'settings',
      },
    },
    {
      path: '/oidcClients/:id',
      name: 'oidcClientsEdit',
      component: OidcClientsSingle,
      meta: {
        title: 'OIDC – Editar Aplicação',
        breadcrumb: 'Editar Aplicação OIDC',
        module: 'settings',
      },
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'notFound',
      component: NotFound,
    },
  ]
}

export const createRouter = (app) => {
  const r = createVueRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    strict: true,
    routes: createRoutes(app),
    scrollBehavior() {
      return { top: 0 }
    },
  })
  r.afterEach((to, _from) => {
    document.title = to.meta.title + ' | ' + orgTerms.name
  })
  return r
}
